import { Col, TabContent, TabPane } from "reactstrap";
import { Href, SettingMenu } from "../../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../../reduxToolkit/hooks";
import Dashboard from "./dashboard";
import MyProperties from "./MyProperties";
import CreateProperty from "./createProperty";
import MyProfile from "./myProfile";
import MyFavorites from "./MyFavorites";
import Privacy from "./Privacy";
import { setDashboardSidebar } from "../../../../../reduxToolkit/reducers/layoutSlice";

const UserDashboardTabs = () => {
  const { activeTab } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();
  return (
    <Col lg="9">
      <a href={Href} className="btn-solid filter-btn mb-sm-4 mb-3" onClick={() => dispatch(setDashboardSidebar())}>
        {SettingMenu}
      </a>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="dashboard">
          <Dashboard />
        </TabPane>
        <TabPane tabId="properties">
          <MyProperties />
        </TabPane>
        <TabPane tabId="create_property">
          <CreateProperty />
        </TabPane>
        <TabPane tabId="profile">
          <MyProfile />
        </TabPane>
        <TabPane tabId="favorites">
          <MyFavorites />
        </TabPane>
        <TabPane tabId="privacy">
          <Privacy />
        </TabPane>
      </TabContent>
    </Col>
  );
};

export default UserDashboardTabs;
